import { Smile } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { EMOJIS } from "./editorUtils";

export function EmojiPicker({ onPick }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" onMouseDown={(e) => e.preventDefault()} title="Emoji" data-testid="nl-tb-emoji"
          className="h-8 w-8 inline-flex items-center justify-center rounded hover:bg-brand-hover text-brand-ink transition-colors"><Smile className="h-4 w-4" /></button>
      </PopoverTrigger>
      <PopoverContent className="w-72 p-2 bg-brand-surface border-brand-border" onOpenAutoFocus={(e) => e.preventDefault()} data-testid="nl-emoji-panel">
        <div className="grid grid-cols-10 gap-0.5 max-h-56 overflow-y-auto">
          {EMOJIS.map((em, i) => (
            <button key={i} type="button" onMouseDown={(e) => { e.preventDefault(); onPick(em); }} data-testid={`nl-emoji-${i}`}
              className="h-7 w-7 text-lg leading-none rounded hover:bg-brand-hover transition-colors">{em}</button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
